import { PopoverContent } from "./content";
import { PopoverItem } from "./item";
import { PopoverRoot } from "./root";
import { PopoverTrigger } from "./trigger";

export const Popover = {
  Root: PopoverRoot,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Item: PopoverItem,
};
